<template>
  <v-container fluid grid-list-sm>
    <v-card>
      <v-toolbar flat>
        <v-toolbar-title>
          <span class="font-weight-medium">
            {{ $t('ITEM.CREATE') }}
            {{ $t('LISTS.ITEM') }}
          </span>
        </v-toolbar-title>

        <v-spacer />

        <v-btn dark color="indigo" @click="$router.go(-1)">
          {{ $t('BUTTON.BACK') }}
        </v-btn>
      </v-toolbar>
      <v-divider />
    </v-card>
    <v-card class="mt-3">
      <v-card-text>
        <v-row>
          <v-col cols="12">
            <documents-lists-form
              v-model="form"
              :errors="errors.getAll()"
              @update-prop="clearErrorByName($event)"
            >
              <template #buttons="{ valid }">
                <v-btn
                  outlined
                  depressed
                  large
                  color="grey"
                  @click="$router.go(-1)"
                >
                  {{ $t('BUTTON.CANCEL') }}
                </v-btn>
                <v-spacer></v-spacer>
                <v-btn
                  large
                  depressed
                  color="success"
                  :disabled="!valid"
                  @click="store"
                >
                  {{ $t('BUTTON.SAVE') }}
                </v-btn>
              </template>
            </documents-lists-form>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import errors from '@/modules/_global/mixins/errors';
import DocumentsListsForm from '@/modules/documents_lists/components/forms/DocumentsListsForm';
import { DocumentsListsService } from '@/services/documents-lists.service';
import { mapActions } from 'vuex';
export default {
  name: 'DocumentsListsCreatePage',
  components: { DocumentsListsForm },

  mixins: [errors],

  data() {
    return {
      form: {
        items: []
      },
      panel: 0
    };
  },

  methods: {
    ...mapActions('snackbar', ['setSnack']),
    store() {
      DocumentsListsService.create(this.form)
        .then(({ data }) => {
          this.setSnack({
            status: 'success',
            text: this.$t('MESSAGE.SUCCESS')
          });
          this.$router.push({
            name: 'documents-lists.show',
            params: { id: data.id }
          });
        })
        .catch(this.handleErrors);
    }
  }
};
</script>

<style scoped></style>
